// pages/HomeTikpontos.js

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./HomeTikpontos.css";

import logoTikpontos from "../assets/home/tikpontos.png";
import heroBanner from "../assets/home/hero-banner.jpg";
import logoTikpag from "../assets/home/tikpag.png";
import img1 from "../assets/home/img1.png";
import img2 from "../assets/home/img2.png";
import img3 from "../assets/home/img3.png";
import img4 from "../assets/home/img4.png";
import imgTikpag from "../assets/home/img-tikpag.png";
import imgNova from "../assets/home/acumule.png";

import AvisoCookies from "../components/AvisoCookies";

export default function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const usuario = token ? JSON.parse(localStorage.getItem("usuario")) : null;

    if (token && usuario?.tipo === "cliente") {
      navigate("/painel-cliente");
    } else if (token && ["admin", "financeiro", "comercial", "logistica"].includes(usuario?.tipo)) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <div className="landing-wrapper">
      <section className="hero">
        <img src={heroBanner} alt="Banner Tikpontos" className="hero-bg" />
        <div className="hero-overlay">
          <header className="hero-header">
            <img src={logoTikpontos} alt="Logo Tikpontos" className="hero-logo" />
            <a href="/login" className="hero-login">Já sou cliente</a>
          </header>

          <div className="hero-content">
            <h1>Transforme operações em prêmios!</h1>
            <p>Com o Tikpontos, cada venda vira uma recompensa. Cadastre-se agora e comece a acumular pontos!</p>
            <a href="/cadastro" className="hero-btn">Criar Conta</a>
          </div>
        </div>
      </section>

      <section className="benefits">
        <h2>Um programa de pontos incrível pra você!</h2>
        <div className="benefit-grid">
          {[
            { img: img1, text: "Agora, todas as suas operações valem! Cadastre e acumule muitos pontos!" },
            { img: img2, text: "Os prêmios chegam rapidinho, direto na sua empresa, com o seu nome!" },
            { img: img3, text: "Participe de campanhas especiais, atinja os pontos e ganhe prêmios incríveis!" },
            { img: img4, text: "Acumule para escolher os melhores prêmios! Seus pontos valem por até 12 meses!" },
          ].map((item, index) => (
            <div key={index} className="benefit-card">
              <img src={item.img} alt={`Benefício ${index + 1}`} style={{ height: "100px", marginBottom: "1rem" }} />
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="tikpag-section">
        <div className="tikpag-container reverse">
          <img src={imgNova} alt="Nova seção" className="tikpag-image" />
          <div>
            <h3>Por que você merece mais!</h3>
            <p>
              Com Tikpontos você acumula pontos e escolhe o que quer ganhar, recebendo seu prêmio na comodidade da sua empresa, sem pagar nenhum centavo por isso.
            </p>
            <p>
              E agora, todas as operações dos seus clientes, realizadas no cartão de crédito valem pontos. Operações em 03 parcelas ou mais acumulam 1 ponto por cada R$1,00, e operações em 01 ou 02 parcelas acumulam 0,20 pontos por cada R$1,00.*Calculados sobre o valor principal sem a inclusão de juros.
            </p>
            <p>
              Seus pontos valem por até 12 meses. Você pode ir acumulando para trocar pelo prêmio que deseja e ainda participar de campanhas sem gastar seus pontos!
            </p>
            <a href="https://www.tikpontos.com.br/cadastro">
              <button className="hero-btn">Cadastre-se agora</button>
            </a>
          </div>
        </div>
      </section>

      <section className="tikpag-section">
        <div className="tikpag-container">
          <img src={imgTikpag} alt="Tikpag" className="tikpag-image" />
          <div>
            <h3>Soluções financeiras para o setor imobiliário</h3>
            <p>
              A Tikpag facilita o pagamento dos seus clientes com tecnologia e segurança e ainda te dá prêmios!
            </p>
            <p>
              Se sua empresa ainda não tem Tikpag, não perca mais tempo! Venha para a Fintech que está mudando a forma de pagar no mercado imobiliário.
            </p>
            <a href="https://tikpag.com.br">
              <button className="hero-btn">Conheça a Tikpag</button>
            </a>
          </div>
        </div>
      </section>

      <footer className="home-footer">
  <div className="footer-left">
    <img src={logoTikpontos} alt="Logo Tikpontos" className="logo-tikpontos" />
    <p>O programa de pontos da Tikpag</p>
  </div>

<div className="footer-right">
  <img src={logoTikpag} alt="Logo Tikpag" className="logo-tikpag" />
  <p>Tikpag Meios de Pagamentos S.A.</p>
  <p>CNPJ 41.016.522/0001-69</p>
  <p>Rua Octaviano Gozzano, 216 - 7º andar</p>
  <p>Infinity Campolim Officel - Sorocaba/SP - CEP 18048-100</p>
  <p><a href="https://tikpag.com.br">www.tikpag.com.br</a></p>
</div>



  <div className="footer-center">
    <p>&copy; {new Date().getFullYear()} Tikpag. Todos os direitos reservados.</p>
  </div>
</footer>



      <AvisoCookies />
    </div>
  );
}